function decodeHtmlSymbols(input: string) {
  const doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

export const parseTextFromHTML = (value?: string) => {
  if (!value) {
    return "";
  }
  const textWithoutTags = value.replace(/<[^>]*>/g, "");
  const decodedText = decodeHtmlSymbols(
    textWithoutTags.replace(/'|"|\n|\t/g, " ")
  );
  if (!decodedText) {
    return "";
  }
  return decodedText;
};
